const initialState = {
  transaction_type: undefined,
  amount: 0,
  already_paid_amount: 0,
  memo: '',
  payment_source: {},
  errors:[],
  ui: {
    show: false,
    is_submitting: false,
  }
}

export default function(state=initialState, action){
  switch(action.type){
    case "FAILED_SUBMIT_MASTER_CHARGE_FORM":
      return {
        ...state,
        errors: action.payload,
        ui: {
          ...state.ui,
          is_submitting: false,
        },
      }
    case "SUCCESS_SUBMIT_MASTER_CHARGE_FORM":
      return { ...initialState }
    case "BEGIN_SUBMIT_MASTER_CHARGE_FORM":
      return {
        ...state,
        ui: {
          ...state.ui,
          is_submitting: true
        }
      }
    case "RESET_MASTER_CHARGE_FORM":
      return {
        ...initialState,
      }
    case "UPDATE_MASTER_CHARGE_FORM_FIELD":
      return {
        ...state,
        ...action.payload
      }
    case "UPDATE_MASTER_CHARGE_FORM_UI":
    return {
      ...state,
      ui: {
        ...state.ui,
        ...action.payload
      }
    }
    default:
      return state
  }
}